import { render, staticRenderFns } from "./NewContractList.vue?vue&type=template&id=b70b4f1c&scoped=true&"
import script from "./NewContractList.vue?vue&type=script&lang=js&"
export * from "./NewContractList.vue?vue&type=script&lang=js&"
import style0 from "./NewContractList.vue?vue&type=style&index=0&id=b70b4f1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70b4f1c",
  null
  
)

export default component.exports